/*! @pentacode/ui v0.1.0 */
//#region ../../node_modules/.pnpm/@awesome.me+webawesome@3.14.0_@floating-ui+utils@0.2.11_@types+node@24.19.2_@types+react@19.2.17/node_modules/@awesome.me/webawesome/dist/chunks/chunk.F25QOBDY.js
function e(e, t) {
	return new Promise((n) => {
		function r(i) {
			i.target === e && (e.removeEventListener(t, r), n());
		}
		e.addEventListener(t, r);
	});
}
//#endregion
export { e as t };

//# sourceMappingURL=chunk.F25QOBDY-D6vAKIyo.js.map